import React, { Component } from 'react';
import { DisplayLink } from '@xo-union/tk-ui-links';

export default class TkLinks extends Component {
  static defaultProps = {
    size: 'md',
    color: 'secondary',
    active: false,
    href: 'javascript:void(0)',
    trackingData: {},
    linkText: '',
    dataClear: false,
    id: null,
    classes: '',
    disabled: null,
    dataApply: false,
    dataSpinnable: false,
    rel: '',
    target: null,
    labelDirection: 'left'
  };

  render() {
    const { ariaLabel, size, color, href, trackingData, linkText, dataClear, active, id, classes, disabled, dataApply, dataSpinnable, rel, target, iconName, labelDirection, ...passThroughProps } = this.props;
     return(
      <DisplayLink id={id}
            size={size}
            aria-label={ariaLabel}
            color={ color }
            href={href}
            data-params={ JSON.stringify(trackingData) }
            data-clear={ dataClear ? 'true' : null }
            className={ classes }
            disabled={ disabled }
            data-apply= { dataApply ? "true" : null }
            data-spinnable= { dataSpinnable ? 'true' : null }
            data-track-results-viewed-event={ trackingData['track-results-viewed-event'] }
            data-track-results-viewed-results-type={ trackingData['track-results-viewed-results-type'] }
            data-track-results-viewed-page-count={ trackingData['track-results-viewed-page-count'] }
            data-track-results-viewed-selected={ trackingData['track-results-viewed-selected'] }
            rel={rel}
            target={target}
            onClick={this.props.onClick}
            iconName={iconName}
            labelDirection={labelDirection}
            { ...passThroughProps }>{linkText}</DisplayLink>
    )
  }
}
